import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Aguardando from '../common/template/aguardando';

import { 
	setModoTela, initForm, setFiltro, salvar, excluir, getListaLogistica as getLista, setFormPedido, 
	getListaDistribuidora, getListaPoliticaPreco, getListaUnidade, getListaMotorista, 
	getListaVeiculo, getListaCliente, getListaEndereco, getListaProduto, getListaCustoPrazo, gerarOrcamento,
	verificaEstoqueManual, verificaAbastecida,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj
} from './pedidoActions';
import { getLista as getListaPedidoPrazo } from '../pedidoPrazo/pedidoPrazoActions';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';

class PedidoLogistica extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
		this.props.setModoTela('lista');
		this.props.getLista();
		this.props.getListaDistribuidora();
		this.props.getListaPoliticaPreco();
		this.props.getListaUnidade();
		this.props.getListaMotorista();
		this.props.getListaVeiculo();
		this.props.getListaCliente();
		this.props.getListaEndereco();
		this.props.getListaProduto();
		this.props.getListaCustoPrazo();
		this.props.verificaEstoqueManual();
		this.props.verificaAbastecida();
		this.props.getListaPedidoTipo();
		this.props.getListaPedidoFrete();
		this.props.getListaPedidoCnpj();
		this.props.getListaPedidoPrazo();

		let idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaDistribuidora();
			this.props.getListaPoliticaPreco();
			this.props.getListaUnidade();
			this.props.getListaMotorista();
			this.props.getListaVeiculo();
			this.props.getListaCliente();
			this.props.getListaEndereco();
			this.props.getListaProduto();
			this.props.getListaCustoPrazo();
			this.props.verificaEstoqueManual();
			this.props.verificaAbastecida();
			this.props.getListaPedidoPrazo();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
	}
	
    render() {

		if (!this.props.estoqueManualLancado) {
			return (
				<div>
					<Content>
						
						<Row>
							<Grid cols='12 12 12 12'>
								<div class="alert alert-danger alert-dismissible">
									<h5><i class="icon fas fa-ban"></i> Operação Bloqueada!</h5>
									<h6>Lance o estoque físico de todas as bases para desbloquear.</h6>
									<h6>Ou lance uma ocorrência do tipo (BASE NÃO REALIZOU LANÇAMENTOS DIÁRIOS).</h6>
								</div>
							</Grid>
						</Row>
					</Content>
				</div>
			);
		}

		if (!this.props.abastecidaLancada) {
			return (
				<div>
					<Content>
						
						<Row>
							<Grid cols='12 12 12 12'>
								<div class="alert alert-danger alert-dismissible">
									<h5><i class="icon fas fa-ban"></i> Operação Bloqueada!</h5>
									<h6>Lance as abastecidas de todas as bases para desbloquear.</h6>
									<h6>Ou lance uma ocorrência do tipo (BASE NÃO REALIZOU LANÇAMENTOS DIÁRIOS).</h6>
								</div>
							</Grid>
						</Row>
					</Content>
				</div>
			);
		}
		
		const lista = this.filtrar();

        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.listaVeiculo.filter(item => item.documentacao_vencida).length > 0 && 
					<Row alignCenter>
						{this.props.listaVeiculo.filter(item => 
							item.documentacao_vencida
							&& lista.filter(pedido => pedido.id_veiculo == item.id).length
						).map(item => (
							<div key={item.id}
								style={{
									backgroundColor: '#de0000',
									color: '#ffffff', 
									margin: 4,
									paddingLeft: 12,
									paddingTop: 4,
									paddingRight: 12,
									paddingBottom: 4,
									borderRadius: 4,
									textAlign: 'center'
								}}>
								<div>
									<i class="icon fas fa-ban"></i> Problemas na documentação!
								</div>
								<div style={{ fontWeight: 'bold' }}>
									{item.valor}
								</div>
							</div>
						))}
					</Row>}

					{this.props.modoTela == 'visualizacao' ? (
						<Form onSubmit={this.props.salvar} visualizacao modoLogistica />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {

		let lista = this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`${DateFormat.formatarDataSqlParaTela(item.data_pedido)} ${item.nome_status}
					${item.giro} ${item.nome_motorista} ${item.placa_veiculo} ${item.nome_usuario_inclusao} ${item.clientes || ''}
				`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		}).filter(item => item.id_usuario_inclusao == (this.props.sessao ? this.props.sessao.id : 0)
			|| (this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica))
		.filter(item => 
			item.id_status == 4 /* Aprovado */
			|| item.id_status == 5 /* Logística Parcial */
			|| item.id_status == 6 /* Logística Finalizada */
			|| item.id_status == 8 /* Abastecida Base e Aguardando Faturar */
		).filter(item => {
			if (this.props.usuarioCarregado && [30, 31, 32].includes(this.props.usuarioCarregado.id_perfil)
				&& this.props.usuarioCarregado.ids_gestao_unidade[0]
				&& this.props.usuarioCarregado.ids_gestao_unidade[0] != item.id_unidade) {
				return false
			}
			return true;
		}).filter(item => {
			if ((this.props.filtro.ids_unidades || []).length && !(this.props.filtro.ids_unidades || []).includes(item.id_unidade)) {
				return false;
			}
			if ((this.props.filtro.ids_clientes || []).length && !(item.itens || []).filter(cli => cli && (this.props.filtro.ids_clientes || []).includes(cli.id_cliente)).length) {
				return false;
			}
			if ((this.props.filtro.ids_motoristas || []).length && !(this.props.filtro.ids_motoristas || []).includes(item.id_motorista)) {
				return false;
			}
			if ((this.props.filtro.ids_veiculos || []).length && !(this.props.filtro.ids_veiculos || []).includes(item.id_veiculo)) {
				return false;
			}

			return true;
		}).map(item => {

			let status = '';
			let ordem = 0;
			if (item.id_status == 4) { /* Aprovado */
				status = 'Aguardando Faturamento';
				ordem = 1;
			} else if (item.id_status == 5) { /* Logística Parcial */
				status = 'Aguardando Faturamento';
				ordem = 1;
			} else if (item.id_status == 6) { /* Logística Finalizada */
				if (item.datahora_fim_carregamento) {
					status = 'Carregamento Finalizado';
					ordem = 5;
				} else if (item.datahora_inicio_carregamento) {
					status = 'Carregamento em Andamento';
					ordem = 4;
				} else {
					status = 'Aguardando Carregamento';
					ordem = 2;
				}
			} else if (item.id_status == 8) { /* Abastecida Base e Aguardando Faturar */
				status = 'Retirado na Base';
				ordem = 3;
			}

			return {
				...item,
				status_logistica: status,
				ordem_logistica: ordem
			}
		});

		lista.sort((a, b) => a.ordem_logistica - b.ordem_logistica);
		
		return lista;
	}

	lista() {

		const lista = this.filtrar();

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<Select
							options={this.props.listaUnidade}
							label='Unidade'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaUnidade.filter(item => (this.props.filtro.ids_unidades || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_unidades: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaCliente}
							label='Cliente'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaCliente.filter(item => (this.props.filtro.ids_clientes || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_clientes: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaMotorista}
							label='Motorista'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaMotorista.filter(item => (this.props.filtro.ids_motoristas || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_motoristas: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaVeiculo}
							label='Veículo'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaVeiculo.filter(item => (this.props.filtro.ids_veiculos || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_veiculos: (values || []).map(item => item.value) });
							}} />
					</Row>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th>Data</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Logística</Th>
								<Th alignCenter>Giro</Th>
								<Th alignCenter>Motorista</Th>
								<Th alignCenter>Placa</Th>
								<Th alignCenter>Vendedor</Th>
								<Th alignCenter>Clientes</Th>
								<Th alignCenter>Aprovação</Th>
								<Th alignCenter>Logística</Th>
								<Th alignCenter>Prev.Entrega</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									style={{ backgroundColor:
										item.id_status == 4 ? '#73d169'
										: (item.id_status == 5 ? '#f285d7' 
											: (item.id_status == 6 ? '#519bf5'
												: '#dffa14'))
									}} >
									<Td>{DateFormat.formatarDataSqlParaTela(item.data_pedido)}</Td>
									<Td alignCenter>{item.nome_status}</Td>
									<Td alignCenter>{item.status_logistica}</Td>
									<Td alignCenter>{item.giro}</Td>
									<Td alignCenter>{item.nome_motorista}</Td>
									<Td alignCenter>{item.placa_veiculo}</Td>
									<Td alignCenter>{item.nome_usuario_inclusao}</Td>
									<Td alignCenter>{item.clientes}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_aprovacao_rejeicao)}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_logistica)}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_primeira_previsao_entrega)}</Td>
									<Td alignRight minWidth={200}>
										<ButtonTable
											type={'primary'}
											icon={'fas fa-eye'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {

												this.props.setFormPedido('pedidoLogistica', 'visualizacao', item);

												// this.props.setModoTela('visualizacao', {
												// 	...item,
												// 	itens: (item.itens || []).map(pedidoItem => ({
												// 		...pedidoItem,
												// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
												// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
												// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
												// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
												// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
												// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
												// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
												// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
												// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
												// 	}))
												// });
												// this.props.initForm({
												// 	...item,
												// 	itens: (item.itens || []).map(pedidoItem => ({
												// 		...pedidoItem,
												// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
												// 			preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
												// 			preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
												// 			preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
												// 			preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
												// 			preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
												// 			valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
												// 			data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
												// 			datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
												// 		}))
												// 	});
											}} />
										<ButtonTable
											type={'primary'}
											icon={'fas fa-download'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.gerarOrcamento(item);
											}} />
										{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica ? (										
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {

													this.props.setFormPedido('pedidoLogistica', 'cadastro', item);

													// this.props.setModoTela('cadastro', {
													// 	...item,
													// 	itens: (item.itens || []).map(pedidoItem => ({
													// 		...pedidoItem,
													// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
													// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
													// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
													// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
													// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
													// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
													// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
													// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
													// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
													// 	}))
													// });
													// this.props.initForm({
													// 	...item,
													// 	itens: (item.itens || []).map(pedidoItem => ({
													// 		...pedidoItem,
													// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
													// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
													// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
													// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
													// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
													// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
													// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
													// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
													// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
													// 	}))
													// });
												}} />
											) : null}
											{this.props.usuarioCarregado && this.props.usuarioCarregado.acesso_logistica ? (
												<ButtonTable
													type={'danger'}
													icon={'fas fa-trash-alt'}
													visible={this.state.linhaSelecionada == item.id}
													event={() => {

														this.props.setFormPedido('pedidoLogistica', 'exclusao', item);

														// this.props.setModoTela('exclusao', {
														// 	...item,
														// 	itens: (item.itens || []).map(pedidoItem => ({
														// 		...pedidoItem,
														// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
														// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
														// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
														// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
														// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
														// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
														// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
														// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
														// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
														// 	}))
														// });
														// this.props.initForm({
														// 	...item,
														// 	itens: (item.itens || []).map(pedidoItem => ({
														// 		...pedidoItem,
														// 		quantidade: FormatUtils.formatarValorTela(pedidoItem.quantidade, 2),
														// 		preco_unitario_bruto: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_bruto, 4),
														// 		preco_unitario_base: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_base, 4),
														// 		preco_unitario_frete: FormatUtils.formatarValorTela(pedidoItem.preco_unitario_frete, 4),
														// 		preco_unitario: FormatUtils.formatarValorTela(pedidoItem.preco_unitario, 4),
														// 		preco_prazo: FormatUtils.formatarValorTela(pedidoItem.preco_prazo, 4),
														// 		valor_total: FormatUtils.formatarValorTela(pedidoItem.valor_total, 2),
														// 		data_emissao_nfe: DateFormat.formatarDataSqlParaTela(pedidoItem.data_emissao_nfe),
														// 		datahora_previsao_entrega: DateFormat.formatarDataHoraSqlParaTela(pedidoItem.datahora_previsao_entrega)
														// 	}))
														// });
													}} />
											) : null}
										</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.pedido.modoTela,
	aguardando: state.pedido.aguardando,
	filtro: state.pedido.filtro,
	usuarioCarregado: state.auth.usuarioCarregado,
	lista: state.pedido.listaLogistica,
    listaVeiculo: state.pedido.listaVeiculo,
	estoqueManualLancado: state.pedido.estoqueManualLancado,
	abastecidaLancada: state.pedido.abastecidaLancada,
	listaUnidade: state.pedido.listaUnidade,
	listaCliente: state.pedido.listaCliente,
	listaMotorista: state.pedido.listaMotorista,
	listaVeiculo: state.pedido.listaVeiculo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, setFiltro, salvar, excluir, getLista, setFormPedido, 
	getListaDistribuidora, getListaPoliticaPreco, getListaUnidade, getListaMotorista, 
	getListaVeiculo, getListaCliente, getListaEndereco, getListaProduto, getListaCustoPrazo, gerarOrcamento,
	verificaEstoqueManual, verificaAbastecida,
	getListaPedidoTipo, getListaPedidoFrete, getListaPedidoCnpj, getListaPedidoPrazo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoLogistica);
